import { createActions } from "redux-actions";

export default createActions({
  TOP: {
    SERVICES: {
      SET: () => ({}),
      SUCCESS: (data) => ({
        data,
      }),
      FAILURE: (error) => ({
        error,
      }),
    },
  },
});
